import { Department } from "../../../api/generated/model";

export type DepartmentOption = {
  value: Department;
  label: string;
};

export const DEPARTMENT_OPTIONS: DepartmentOption[] = [
  { value: Department.Building, label: "Bygg" },
  { value: Department.Scaffolding, label: "Ställning" },
  { value: Department.WeatherProtection, label: "Väderskydd" },
  { value: Department.Elevator, label: "Hiss" },
];
